import React from 'react';
import { ClockIcon, MailIcon, MapPinIcon, PhoneIcon, SparklesIcon, TrendingUpIcon } from 'lucide-react';
import { images } from '../data/content';
const pipeline = [{
  stage: 'New leads',
  count: 14,
  width: 'w-full'
}, {
  stage: 'Contacted',
  count: 9,
  width: 'w-[64%]'
}, {
  stage: 'Appointment set',
  count: 5,
  width: 'w-[36%]'
}, {
  stage: 'Under contract',
  count: 2,
  width: 'w-[16%]'
}];
const tasks = [{
  icon: PhoneIcon,
  label: 'Call back Whitaker referral',
  meta: 'Due 4:15 PM',
  due: true
}, {
  icon: MailIcon,
  label: 'Day 3 nurture email sent',
  meta: 'Automated',
  due: false
}, {
  icon: ClockIcon,
  label: 'Open house follow-up reminder',
  meta: 'Tomorrow, 9 AM',
  due: false
}];

/** Product-style visual: CRM pipeline, task follow-up, automation, and market data. */
export function WorkflowMock() {
  return <div className="overflow-hidden rounded-2xl border border-line bg-white shadow-[0_30px_70px_-45px_rgba(11,26,43,0.5)]" data-id="element-218" data-mp="33i9ylot6gsb9">
      <div className="flex items-center gap-2 border-b border-line bg-canvas px-4 py-3" data-id="element-219" data-mp="38buwzhyonoaz">
        <span className="h-2 w-2 rounded-full bg-accent" data-id="element-220" data-mp="apkktzjpxved" />
        <p className="font-display text-[13px] font-semibold text-ink" data-id="element-221" data-mp="5qzinukwp1na">Agent workspace</p>
        <span className="ml-auto text-[11px] font-medium text-ink-400" data-id="element-222" data-mp="kfma2unt5juv">Phoenix metro • This week</span>
      </div>

      <div className="grid gap-4 p-4 sm:grid-cols-2 md:p-5" data-id="element-223" data-mp="fncmvme2uxwa">
        <section className="rounded-xl border border-line p-4" data-id="element-224" data-mp="tfsii24nftn6">
          <h4 className="text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-400" data-id="element-225" data-mp="te7pwi1wakry">Pipeline</h4>
          <ul className="mt-3 space-y-3" data-id="element-226" data-mp="ogfyrq92r2ot">
            {pipeline.map(row => <li key={row.stage} data-id="element-227" data-mp="13cncq8tw37vn">
                <div className="flex items-baseline justify-between" data-id="element-228" data-mp="13bm2u7om0rfi">
                  <span className="text-[13px] font-medium text-ink" data-id="element-229" data-mp="yfeygjbv3nzo">{row.stage}</span>
                  <span className="font-display text-[13px] font-semibold text-ink-600" data-id="element-230" data-mp="3564l5epugcrg">{row.count}</span>
                </div>
                <div className="mt-1.5 h-1.5 w-full rounded-full bg-canvas" data-id="element-231" data-mp="308bhasc0juuc">
                  <div className={`h-full rounded-full bg-ink ${row.width}`} data-id="element-232" data-mp="3pvypny5ybclf" />
                </div>
              </li>)}
          </ul>
        </section>

        <section className="rounded-xl border border-line p-4" data-id="element-233" data-mp="2p4z59v85z64">
          <h4 className="text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-400" data-id="element-234" data-mp="2s0z13qmuxx7">Follow-up queue</h4>
          <ul className="mt-3 space-y-2.5" data-id="element-235" data-mp="cnucqqg38xgk">
            {tasks.map(task => <li key={task.label} className="flex items-start gap-2.5" data-id="element-236" data-mp="cm1d3v3w7di2">
                <span className={`mt-[1px] flex h-6 w-6 shrink-0 items-center justify-center rounded-md ${task.due ? 'bg-accent-soft' : 'bg-canvas'}`} data-id="element-237" data-mp="gnwe0yhwvovb">
                  <task.icon className={`h-3.5 w-3.5 ${task.due ? 'text-accent' : 'text-ink-400'}`} aria-hidden="true" data-id="element-238" data-mp="qh3ec4xsoeoj" />
                </span>
                <span className="min-w-0" data-id="element-239" data-mp="10b2cksuqzeb7">
                  <span className="block truncate text-[13px] font-medium text-ink" data-id="element-240" data-mp="2kwim040lyca7">{task.label}</span>
                  <span className="text-[11px] text-ink-400" data-id="element-241" data-mp="2fvcq5xbni8wg">{task.meta}</span>
                </span>
              </li>)}
          </ul>
        </section>

        <section className="rounded-xl bg-ink p-4 text-white" data-id="element-242" data-mp="25ygghoa0ngqb">
          <div className="flex items-center gap-2" data-id="element-243" data-mp="2601b1dwbyzo6">
            <SparklesIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-244" data-mp="33m8geq0gkw1l" />
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.12em] text-white/60" data-id="element-245" data-mp="2yn5lhye7067c">AI assist</h4>
          </div>
          <p className="mt-3 text-[13px] leading-relaxed text-white/80" data-id="element-246" data-mp="2tvdslh7kdoe1">
            Draft ready: a market update for 11 past clients in Gilbert, based on MLS activity from the last 30 days.
          </p>
          <div className="mt-3 flex items-center gap-2 text-[11px] font-medium text-white/60" data-id="element-247" data-mp="3mdi1lwjld990">
            <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-248" data-mp="3hkoy1bzv06yi" />
            Gilbert, AZ
            <TrendingUpIcon className="ml-2 h-3.5 w-3.5" aria-hidden="true" data-id="element-249" data-mp="323guyl4hp4lt" />
            Median days on market: 34
          </div>
        </section>

        <section className="overflow-hidden rounded-xl border border-line" data-id="element-250" data-mp="370qjlyk21c8l">
          <img src={images.workflow} alt="Two real estate professionals reviewing performance data on a monitor" width={1680} height={945} loading="lazy" decoding="async" style={{
          objectPosition: '45% 35%'
        }} className="h-[120px] w-full object-cover sm:h-full" data-id="element-251" data-mp="2s73r4uf8dadc" />
        </section>
      </div>
    </div>;
}